import {
  NUTRIENTS_ENUM,
  NutrientType,
} from '../../../../shared/constants/NUTRIENTS_ENUM';
import { RecipeMacros } from '../../../interfaces/RecipeMacros';

export type RecipeMacroKey = keyof RecipeMacros;

/** display order of both nutrient cards and the ingredient previews */
export const RECIPE_MACROS = [
  { key: 'proteins', label: 'Proteins', nutrient: NUTRIENTS_ENUM.PROTEINS },
  { key: 'carbs', label: 'Carbs', nutrient: NUTRIENTS_ENUM.CARBS },
  { key: 'fats', label: 'Fats', nutrient: NUTRIENTS_ENUM.FATS },
  { key: 'sugar', label: 'Sugar', nutrient: NUTRIENTS_ENUM.SUGAR },
  { key: 'fiber', label: 'Fiber', nutrient: NUTRIENTS_ENUM.FIBER },
  { key: 'veggies', label: 'Veggies', nutrient: NUTRIENTS_ENUM.VEGGIES },
  { key: 'sodium', label: 'Sodium', nutrient: NUTRIENTS_ENUM.SODIUM },
  { key: 'calorie', label: 'Calories', nutrient: NUTRIENTS_ENUM.CALORIES },
] as const satisfies {
  key: RecipeMacroKey;
  label: string;
  nutrient: NutrientType;
}[];

export const RECIPE_MACRO_KEYS: RecipeMacroKey[] = RECIPE_MACROS.map(({ key }) => key);

/** the backend deserialises ingredient amounts at 3 decimals */
export const INGREDIENT_ROUNDING_PRECISION: number = 3;
